<div class="monitor-layout">
    <!-- Implementación de Tabs -->
    <mat-tab-group animationDuration="0ms" (selectedIndexChange)="onTabChange($event)"
        [selectedIndex]="activeTabSignal()" class="top-tabs">
        <mat-tab label="Facturas"></mat-tab>
        <mat-tab label="Pre-facturas" [disabled]="true"></mat-tab>
        <mat-tab label="Remisiones"></mat-tab>
    </mat-tab-group>

    <div class="monitor-container">
        <!-- Nuevo Header Unificado: Atrás | Título | Analysis Status -->
        <div class="unified-header">
            <div class="header-left">
                <button mat-icon-button (click)="goBack()" class="circular-button back-button" matTooltip="Regresar">
                    <mat-icon>arrow_back</mat-icon>
                </button>
                <h1 class="page-title">
                    <mat-icon class="title-icon">business</mat-icon>
                    {{ currentTitle() }}
                </h1>
            </div>

            <!-- Analysis Status Widget (siempre visible) -->
            <!-- Analysis Status Widget (siempre visible) -->
            <div class="analysis-status-container">
                <app-analysis-status-card></app-analysis-status-card>
            </div>
        </div>

        <!-- Barra de Filtros Compacta -->
        <mat-expansion-panel class="filters-panel" [expanded]="false">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <div style="display: flex; align-items: center; gap: 6px;">
                        <mat-icon>filter_list</mat-icon>
                        <span>Filtros</span>
                        <!-- Spinner local alineado inmediatamente después de "Filtros" -->
                        @if (isLoadingSignal()) {
                        <mat-progress-spinner mode="indeterminate" diameter="20" class="filter-spinner"
                            style="margin-left: 2px;"></mat-progress-spinner>
                        }
                    </div>
                </mat-panel-title>
                <mat-panel-description>
                    <span>{{ totalFacturasFiltradasSignal() }} resultados</span>
                </mat-panel-description>
            </mat-expansion-panel-header>

            <form [formGroup]="filtroForm" class="filters-row">
                <mat-form-field appearance="outline" class="dense-field" subscriptSizing="dynamic">
                    <mat-label>Buscar</mat-label>
                    <input matInput formControlName="textoGeneral" />
                    <mat-icon matPrefix>search</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline" class="dense-field" subscriptSizing="dynamic">
                    <mat-label>Emisor</mat-label>
                    <input type="text" matInput formControlName="emisor" [matAutocomplete]="autoEmisor" />
                    <mat-autocomplete #autoEmisor="matAutocomplete">
                        @for (option of filteredEmisores$ | async; track option) {
                        <mat-option [value]="option">{{ option }}</mat-option>
                        }
                    </mat-autocomplete>
                </mat-form-field>

                <mat-form-field appearance="outline" class="dense-field" subscriptSizing="dynamic">
                    <mat-label>Cliente</mat-label>
                    <input type="text" matInput formControlName="cliente" [matAutocomplete]="autoCliente" />
                    <mat-autocomplete #autoCliente="matAutocomplete">
                        @for (option of filteredClientes$ | async; track option) {
                        <mat-option [value]="option">{{ option }}</mat-option>
                        }
                    </mat-autocomplete>
                </mat-form-field>

                @if (activeTabSignal() !== 2) {
                <mat-form-field appearance="outline" class="dense-field" subscriptSizing="dynamic">
                    <mat-label>RFC</mat-label>
                    <input type="text" matInput formControlName="rfc" [matAutocomplete]="autoRfc" />
                    <mat-autocomplete #autoRfc="matAutocomplete">
                        @for (option of filteredRfcs$ | async; track option) {
                        <mat-option [value]="option">{{ option }}</mat-option>
                        }
                    </mat-autocomplete>
                </mat-form-field>
                }

                <mat-form-field appearance="outline" class="dense-field status-field" subscriptSizing="dynamic">
                    <mat-label>Estatus</mat-label>
                    <mat-select formControlName="estatus">
                        <mat-option value="">Todos</mat-option>
                        @for (est of estatusDisponibles(); track est) {
                        <mat-option [value]="est">{{ est }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>

                <div class="filter-actions-inline">
                    <button mat-icon-button color="primary" (click)="limpiarFiltros()" type="button"
                        matTooltip="Limpiar Filtros">
                        <mat-icon>filter_alt_off</mat-icon>
                    </button>
                    <button mat-icon-button color="accent" (click)="forzarRefrescoCompleto()" type="button"
                        matTooltip="Refrescar">
                        <mat-icon>refresh</mat-icon>
                    </button>
                </div>
            </form>
        </mat-expansion-panel>

        <div class="controles-superiores">
            <mat-checkbox (change)="onSelectAllFiltradasChange($event)" [checked]="todasSeleccionadasSignal()"
                [disabled]="totalFacturasFiltradasSignal() === 0 || isLoadingSignal() || isUpdatingStatusSignal()"
                matTooltip="Seleccionar/Deseleccionar todas las facturas que coinciden con los filtros">
                Sel. Todas {{ totalFacturasFiltradasSignal() }}
            </mat-checkbox>

            <mat-form-field appearance="outline" class="dense-field select-cambio-estatus" subscriptSizing="dynamic">
                <mat-label>Cambiar Estatus</mat-label>
                <mat-select [(ngModel)]="estatusSeleccionadoParaCambio"
                    [disabled]="isLoadingSignal() || isUpdatingStatusSignal()">
                    @for (est of estatusDisponibles(); track est) {
                    <mat-option [value]="est">{{ est }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <button mat-icon-button color="primary" (click)="aplicarCambioDeEstatus()"
                [disabled]="!estatusSeleccionadoParaCambio || getSelectedInvoiceCount() === 0 || isLoadingSignal() || isUpdatingStatusSignal()"
                matTooltip="Guardar Cambios">
                @if (!isUpdatingStatusSignal()) {
                <mat-icon>save</mat-icon>
                } @else {
                <mat-progress-spinner mode="indeterminate" diameter="24"></mat-progress-spinner>
                }
            </button>

            <span class="spacer"></span>

            <button mat-stroked-button (click)="openUploadStatusDialog()" style="font-size: 12px;"
                [disabled]="isLoadingSignal() || isUpdatingStatusSignal()">
                <mat-icon style="color: #1D6F42;">description</mat-icon>
                <span>Cargar Plantilla</span>
            </button>

            <button mat-stroked-button (click)="exportarExcel()" style="font-size: 12px;"
                [disabled]="isLoadingSignal() || totalFacturasFiltradasSignal() === 0"
                matTooltip="Exportar a Excel lo visible con los filtros aplicados">
                <mat-icon style="color: #1D6F42;">table_view</mat-icon>
                <span>Exportar Excel</span>
            </button>

            <button mat-stroked-button (click)="openUploadArmstrongDialog()" style="font-size: 12px;"
                [disabled]="isLoadingSignal() || isUpdatingStatusSignal()">
                <mat-icon style="color: #3D6091;">upload_file</mat-icon>
                <span>Importar Excel</span>
            </button>

            <mat-paginator [length]="totalFacturasFiltradasSignal()" [pageSize]="pageEventSignal().pageSize"
                [pageIndex]="pageEventSignal().pageIndex" [pageSizeOptions]="[20, 40, 60, 80]"
                (page)="pageEventSignal.set($event)" showFirstLastButtons
                [disabled]="isLoadingSignal() || isUpdatingStatusSignal()">
            </mat-paginator>
        </div>

        @if (paginatedInvoicesSignal().length > 0) {
        <mat-accordion [multi]="false" class="facturas-accordion">
            @for (invoice of paginatedInvoicesSignal(); track invoice.id) {
            <mat-expansion-panel [disabled]="isLoadingSignal() || isUpdatingStatusSignal()">
                <mat-expansion-panel-header>
                    <mat-panel-title class="panel-title-container">
                        <mat-checkbox [checked]="invoice.seleccionada"
                            (change)="onFacturaSelectionChange(invoice.id, $event.checked)"
                            (click)="$event.stopPropagation()" class="panel-checkbox"
                            [disabled]="isLoadingSignal() || isUpdatingStatusSignal()"></mat-checkbox>

                        <div class="factura-info-group">
                            <div class="info-item">
                                <span class="info-label">Folio Documento:</span>
                                <span class="info-value folio">{{ invoice.documentFolio || 'N/A' }}</span>
                                <button mat-icon-button class="copy-button"
                                    [cdkCopyToClipboard]="invoice.documentFolio || ''"
                                    (click)="$event.stopPropagation(); onCopyToClipboard(invoice.documentFolio || '')"
                                    matTooltip="Copiar Folio Documento"><mat-icon>content_copy</mat-icon></button>
                            </div>

                            <div class="info-item">
                                <span class="info-label">
                                    @if (activeTabSignal() === 2) { Folio Remisión: }
                                    @else { Serie-Folio: }
                                </span>
                                @if (activeTabSignal() === 2) {
                                <!-- Mostrar solo folioRemision para Remisiones -->
                                @switch (getFieldDisplayState(invoice.folioRemision, 'folio_remision')) {
                                @case ('VALIDO') { <span class="info-value">{{ invoice.folioRemision }}</span> }
                                @case ('PROCESANDO') { <span class="info-value processing-text">Procesando...</span> }
                                @case ('NO_ENCONTRADO') { <span class="info-value not-found-text">No Encontrado</span> }
                                @case ('REVISION_REQUERIDA') { <span class="info-value revision-text">Requiere
                                    Revisión</span> }
                                }
                                } @else {
                                <!-- Lógica actual para Facturas/Pre-facturas -->
                                @switch (getSerieFolioState(invoice.serie, invoice.folio)) {
                                @case ('VALIDO') {
                                <span class="info-value">
                                    {{ formatSerieFolio(invoice.serie, invoice.folio) }}
                                </span>
                                }
                                @case ('PROCESANDO') { <span class="info-value processing-text">Procesando...</span> }
                                @case ('NO_ENCONTRADO') { <span class="info-value not-found-text">No Encontrado</span> }
                                @case ('REVISION_REQUERIDA') { <span class="info-value revision-text">Requiere
                                    Revisión</span> }
                                }
                                }
                            </div>

                            <!-- Ocultar UUID si es Remisión (Tab 2) -->
                            @if (activeTabSignal() !== 2) {
                            <div class="info-item">
                                <span class="info-label">CFDI (UUID):</span>
                                @switch (getFieldDisplayState(invoice.uuid, 'cfdi_uuid')) {
                                @case ('VALIDO') { <span class="info-value">{{ invoice.uuid }}</span> }
                                @case ('PROCESANDO') { <span class="info-value processing-text">Procesando...</span> }
                                @case ('NO_ENCONTRADO') { <span class="info-value not-found-text">No Encontrado</span> }
                                @case ('REVISION_REQUERIDA') { <span class="info-value revision-text">Requiere
                                    Revisión</span> }
                                }
                                @if(getFieldDisplayState(invoice.uuid, 'cfdi_uuid') === 'VALIDO') {
                                <button mat-icon-button class="copy-button" [cdkCopyToClipboard]="invoice.uuid || ''"
                                    (click)="$event.stopPropagation(); onCopyToClipboard(invoice.uuid || '')"
                                    matTooltip="Copiar UUID"><mat-icon>content_copy</mat-icon></button>
                                }
                            </div>
                            }
                        </div>

                        <div class="factura-info-group">
                            <div class="info-item">
                                <span class="info-label">Nombre Emisor:</span>
                                @switch (getFieldDisplayState(invoice.emisorNombre, 'emisor_nombre')) {
                                @case ('VALIDO') { <span class="info-value">{{ invoice.emisorNombre }}</span> }
                                @case ('PROCESANDO') { <span class="info-value processing-text">Procesando...</span> }
                                @case ('NO_ENCONTRADO') { <span class="info-value not-found-text">No Encontrado</span> }
                                @case ('REVISION_REQUERIDA') { <span class="info-value revision-text">Requiere
                                    Revisión</span> }
                                }
                            </div>
                            @if (activeTabSignal() !== 2) {
                            <div class="info-item">
                                <span class="info-label">RFC Emisor:</span>
                                @switch (getFieldDisplayState(invoice.emisorRFC, 'emisor_rfc')) {
                                @case ('VALIDO') { <span class="info-value">{{ invoice.emisorRFC }}</span> }
                                @case ('PROCESANDO') { <span class="info-value processing-text">Procesando...</span> }
                                @case ('NO_ENCONTRADO') { <span class="info-value not-found-text">No Encontrado</span> }
                                @case ('REVISION_REQUERIDA') { <span class="info-value revision-text">Requiere
                                    Revisión</span> }
                                }
                            </div>
                            }
                        </div>

                        <div class="factura-info-group">
                            <div class="info-item">
                                <span class="info-label">Nombre Receptor:</span>
                                @switch (getFieldDisplayState(invoice.receptorNombre, 'receptor_nombre')) {
                                @case ('VALIDO') { <span class="info-value">{{ invoice.receptorNombre }}</span> }
                                @case ('PROCESANDO') { <span class="info-value processing-text">Procesando...</span> }
                                @case ('NO_ENCONTRADO') { <span class="info-value not-found-text">No Encontrado</span> }
                                @case ('REVISION_REQUERIDA') { <span class="info-value revision-text">Requiere
                                    Revisión</span> }
                                }
                            </div>
                            @if (activeTabSignal() !== 2) {
                            <div class="info-item">
                                <span class="info-label">RFC Receptor:</span>
                                @switch (getFieldDisplayState(invoice.receptorRFC, 'receptor_rfc')) {
                                @case ('VALIDO') { <span class="info-value">{{ invoice.receptorRFC }}</span> }
                                @case ('PROCESANDO') { <span class="info-value processing-text">Procesando...</span> }
                                @case ('NO_ENCONTRADO') { <span class="info-value not-found-text">No Encontrado</span> }
                                @case ('REVISION_REQUERIDA') { <span class="info-value revision-text">Requiere
                                    Revisión</span> }
                                }
                            </div>
                            }
                        </div>

                        <div class="factura-info-group align-right">
                            <div class="info-item">
                                <span class="info-label">Total:</span>
                                @switch (getFieldDisplayState(invoice.total, 'total')) {
                                @case ('VALIDO') { <span class="info-value total">{{ invoice.total | currency }}</span>
                                }
                                @case ('PROCESANDO') { <span class="info-value processing-text">Procesando...</span> }
                                @case ('NO_ENCONTRADO') { <span class="info-value not-found-text">No Encontrado</span> }
                                @case ('REVISION_REQUERIDA') { <span class="info-value revision-text">Requiere
                                    Revisión</span> }
                                }
                            </div>
                            <div class="info-item">
                                <span class="info-label">
                                    @if (activeTabSignal() === 2) { Fecha de Remisión: }
                                    @else { Fecha de Emisión: }
                                </span>
                                @if (activeTabSignal() === 2) {
                                @switch (getFieldDisplayState(invoice.fechaRemision, 'fecha_remision')) {
                                @case ('VALIDO') { <span class="info-value">{{ invoice.fechaRemision | date :
                                    'dd/MM/yyyy' }}</span> }
                                @case ('PROCESANDO') { <span class="info-value processing-text">Procesando...</span> }
                                @case ('NO_ENCONTRADO') { <span class="info-value not-found-text">No Encontrado</span> }
                                @case ('REVISION_REQUERIDA') { <span class="info-value revision-text">Requiere
                                    Revisión</span> }
                                }
                                } @else {
                                @switch (getFieldDisplayState(invoice.fechaEmision, 'fecha_emision')) {
                                @case ('VALIDO') { <span class="info-value">{{ invoice.fechaEmision | date :
                                    'dd/MM/yyyy' }}</span> }
                                @case ('PROCESANDO') { <span class="info-value processing-text">Procesando...</span> }
                                @case ('NO_ENCONTRADO') { <span class="info-value not-found-text">No Encontrado</span> }
                                @case ('REVISION_REQUERIDA') { <span class="info-value revision-text">Requiere
                                    Revisión</span> }
                                }
                                }
                            </div>
                        </div>

                        <div class="factura-info-group status-group">
                            <span
                                class="factura-info estatus status-{{ invoice.estatus ? invoice.estatus.split(' ').join('-') : 'unknown' }}"
                                [style.background]="getStatusColor(invoice.estatus)">{{
                                getStatusName(invoice.estatus) || 'Desconocido' }}</span>
                            @if (hasMissingRfc(invoice)) {
                            <span class="no-rfc-chip" matTooltip="El emisor/proveedor no tiene RFC capturado. Complételo en el Catálogo de Operadores Logísticos.">
                                <mat-icon>warning</mat-icon> Sin RFC
                            </span>
                            }
                            <button mat-icon-button class="edit-button" (click)="openEditInvoiceDialog(invoice, $event)"
                                matTooltip="Editar datos del documento">
                                <mat-icon>edit</mat-icon>
                            </button>
                        </div>


                    </mat-panel-title>
                </mat-expansion-panel-header>

                <div class="factura-detalle">
                    <!-- Sección de Datos de Licitación/Contrato (Solo para Remisiones) -->
                    @if (activeTabSignal() === 2 && (invoice.folioContrato || invoice.folioLicitacion)) {
                    <div class="referral-details-container">
                        <h4>📄 Datos de Licitación y Contrato</h4>
                        <div class="details-grid">
                            @if (invoice.folioContrato) {
                            <div class="detail-item">
                                <span class="detail-label">Folio Contrato:</span>
                                @switch (getFieldDisplayState(invoice.folioContrato, 'folio_contrato')) {
                                @case ('VALIDO') { <span class="detail-value">{{ invoice.folioContrato }}</span> }
                                @case ('NO_ENCONTRADO') { <span class="info-value not-found-text">No Encontrado</span> }
                                @case ('REVISION_REQUERIDA') { <span class="info-value revision-text">Requiere
                                    Revisión</span> }
                                @default { <span class="detail-value">{{ invoice.folioContrato }}</span> }
                                }
                            </div>
                            }
                            @if (invoice.folioLicitacion) {
                            <div class="detail-item">
                                <span class="detail-label">Folio Licitación:</span>
                                @switch (getFieldDisplayState(invoice.folioLicitacion, 'folio_licitacion')) {
                                @case ('VALIDO') { <span class="detail-value">{{ invoice.folioLicitacion }}</span> }
                                @case ('NO_ENCONTRADO') { <span class="info-value not-found-text">No Encontrado</span> }
                                @case ('REVISION_REQUERIDA') { <span class="info-value revision-text">Requiere
                                    Revisión</span> }
                                @default { <span class="detail-value">{{ invoice.folioLicitacion }}</span> }
                                }
                            </div>
                            }
                        </div>
                    </div>
                    }

                    <!-- Sección de Datos de Proveedor (Solo para Remisiones) -->
                    @if (activeTabSignal() === 2 && (invoice.proveedorNombre || invoice.proveedorRFC ||
                    invoice.proveedorFolio)) {
                    <div class="referral-details-container">
                        <h4>🏢 Datos de Proveedor</h4>
                        <div class="details-grid">
                            @if (invoice.proveedorNombre) {
                            <div class="detail-item">
                                <span class="detail-label">Proveedor:</span>
                                @switch (getFieldDisplayState(invoice.proveedorNombre, 'proveedor_nombre')) {
                                @case ('VALIDO') { <span class="detail-value">{{ invoice.proveedorNombre }}</span> }
                                @case ('NO_ENCONTRADO') { <span class="info-value not-found-text">No Encontrado</span> }
                                @case ('REVISION_REQUERIDA') { <span class="info-value revision-text">Requiere
                                    Revisión</span> }
                                @default { <span class="detail-value">{{ invoice.proveedorNombre }}</span> }
                                }
                            </div>
                            }
                            @if (invoice.proveedorRFC) {
                            <div class="detail-item">
                                <span class="detail-label">RFC Proveedor:</span>
                                @switch (getFieldDisplayState(invoice.proveedorRFC, 'proveedor_rfc')) {
                                @case ('VALIDO') { <span class="detail-value">{{ invoice.proveedorRFC }}</span> }
                                @case ('NO_ENCONTRADO') { <span class="info-value not-found-text">No Encontrado</span> }
                                @case ('REVISION_REQUERIDA') { <span class="info-value revision-text">Requiere
                                    Revisión</span> }
                                @default { <span class="detail-value">{{ invoice.proveedorRFC }}</span> }
                                }
                            </div>
                            }
                            @if (invoice.proveedorFolio) {
                            <div class="detail-item">
                                <span class="detail-label">Número Proveedor:</span>
                                @switch (getFieldDisplayState(invoice.proveedorFolio, 'proveedor_folio')) {
                                @case ('VALIDO') { <span class="detail-value">{{ invoice.proveedorFolio }}</span> }
                                @case ('NO_ENCONTRADO') { <span class="info-value not-found-text">No Encontrado</span> }
                                @case ('REVISION_REQUERIDA') { <span class="info-value revision-text">Requiere
                                    Revisión</span> }
                                @default { <span class="detail-value">{{ invoice.proveedorFolio }}</span> }
                                }
                            </div>
                            }
                        </div>
                    </div>
                    }

                    <!-- Sección Armstrong (datos de origen) -->
                    @if (invoice.clave || invoice.entidadFederativa || invoice.almacen || invoice.fechaPago || invoice.fechaIngresoCobro || invoice.estatusPortal) {
                    <div class="referral-details-container">
                        <h4>Datos Armstrong</h4>
                        <div class="details-grid">
                            @if (invoice.clave) {
                            <div class="detail-item">
                                <span class="detail-label">Clave:</span>
                                <span class="detail-value">{{ invoice.clave }}</span>
                            </div>
                            }
                            @if (invoice.entidadFederativa) {
                            <div class="detail-item">
                                <span class="detail-label">Entidad Federativa:</span>
                                <span class="detail-value">{{ invoice.entidadFederativa }}</span>
                            </div>
                            }
                            @if (invoice.almacen) {
                            <div class="detail-item">
                                <span class="detail-label">Almacén:</span>
                                <span class="detail-value">{{ invoice.almacen }}</span>
                            </div>
                            }
                            @if (invoice.fechaPago) {
                            <div class="detail-item">
                                <span class="detail-label">Fecha de Pago:</span>
                                <span class="detail-value">{{ invoice.fechaPago }}</span>
                            </div>
                            }
                            @if (invoice.fechaIngresoCobro) {
                            <div class="detail-item">
                                <span class="detail-label">Fecha Ingreso a Cobro:</span>
                                <span class="detail-value">{{ invoice.fechaIngresoCobro }}</span>
                            </div>
                            }
                            @if (invoice.estatusPortal) {
                            <div class="detail-item">
                                <span class="detail-label">Estatus Portal:</span>
                                <span class="detail-value">{{ invoice.estatusPortal }}</span>
                            </div>
                            }
                        </div>
                    </div>
                    }

                    <!-- Historial de Cambios -->
                    <div class="status-history-container">
                        <h4>📋 Historial de Cambios</h4>
                        @if(invoice.statusHistory && invoice.statusHistory.length > 0) {
                        <div class="history-scroll-container">
                            @let grouped = groupStatusHistory(invoice.statusHistory);

                            <!-- Card para el último cambio de IA (si existe) -->
                            @if (grouped.iaChanges.length > 0) {
                            @let lastIAEvent = grouped.iaChanges[grouped.iaChanges.length - 1];
                            <div class="history-card ia-grouped-card">
                                <div class="history-card-status">
                                    <mat-icon class="status-icon">description</mat-icon>
                                    Procesamiento del Documento
                                </div>
                                <div class="history-card-date">
                                    <mat-icon>schedule</mat-icon>
                                    {{ lastIAEvent.fecha | date : 'dd/MM/yy HH:mm' }}
                                </div>
                                @if (lastIAEvent.observacion) {
                                <div class="history-card-obs">{{ lastIAEvent.observacion }}</div>
                                }
                                @if (grouped.iaChanges.length > 1) {
                                <div class="ia-count-badge">+{{ grouped.iaChanges.length - 1 }} eventos anteriores</div>
                                }
                            </div>
                            }

                            <!-- Cards individuales para cambios manuales -->
                            @for(history of grouped.manualChanges; track history.fecha) {
                            <div class="history-card">
                                <div class="history-card-status">{{ getStatusName(history.estatus) }}</div>
                                <div class="history-card-date">
                                    <mat-icon>schedule</mat-icon>
                                    {{ history.fecha | date : 'dd/MM/yy HH:mm' }}
                                </div>
                                @if (history.observacion) {
                                <div class="history-card-obs">{{ history.observacion }}</div>
                                }
                            </div>
                            }
                        </div>
                        } @else {
                        <p class="no-history">Sin historial</p>
                        }
                    </div>
                </div>
            </mat-expansion-panel>
            }
        </mat-accordion>
        } @else if (!isLoadingSignal() && totalFacturasFiltradasSignal() === 0) {
        <div class="no-facturas">
            <mat-icon>inbox</mat-icon>
            <p>No se encontraron documentos con los filtros aplicados.</p>
        </div>
        }

        <!-- Paginador Inferior -->
        @if (!isLoadingSignal() && totalFacturasFiltradasSignal() > pageEventSignal().pageSize) {
        <div class="bottom-paginator">
            <mat-paginator [length]="totalFacturasFiltradasSignal()" [pageSize]="pageEventSignal().pageSize"
                [pageIndex]="pageEventSignal().pageIndex" [pageSizeOptions]="[20, 40, 60, 80]"
                (page)="pageEventSignal.set($event)" showFirstLastButtons></mat-paginator>
        </div>
        }
    </div>
</div>